import { useNavigate } from 'react-router-dom';

import { PRIVATE } from 'router/routes';

import Burger from 'components/Burger';
import Logo from 'components/Logo';
import { useSidebar } from 'components/Sidebar/hooks';

import * as S from './styled';

const Header = ({ noControls }: { noControls?: boolean }) => {
    const navigate = useNavigate();

    const { isOpen, toggle, close } = useSidebar();

    const handleRedirect = () => {
        navigate(PRIVATE.ACCOUNT_DEFAULT.path);
        close();
    };

    return (
        <S.HeaderContainer>
            <S.TitleContainer>
                {noControls && <Burger onClick={toggle} isActive={isOpen} />}
                <Logo />
            </S.TitleContainer>
            {noControls && <S.AvatarImage onClick={handleRedirect} />}
        </S.HeaderContainer>
    );
};

export default Header;
